import React from 'react';
import { Bike, BusFront, CarFront, CircleDot, Truck } from 'lucide-react';

export const vehicleTypeLabels = {
  car: 'Carro',
  motorcycle: 'Moto',
  truck: 'Caminhao',
  van: 'Van',
  bus: 'Onibus',
  other: 'Outro',
};

const vehicleTypeIcons = {
  car: CarFront,
  motorcycle: Bike,
  truck: Truck,
  van: Truck,
  bus: BusFront,
  other: CircleDot,
};

export const normalizeVehicleType = (vehicleOrType) => {
  const rawType = typeof vehicleOrType === 'string'
    ? vehicleOrType
    : vehicleOrType?.type || vehicleOrType?.icon;

  if (rawType === 'motorbike' || rawType === 'moto') return 'motorcycle';
  if (rawType === 'pickup') return 'truck';

  return vehicleTypeLabels[rawType] ? rawType : 'other';
};

export const getVehicleTypeLabel = (vehicleOrType) => {
  const type = normalizeVehicleType(vehicleOrType);
  return vehicleTypeLabels[type] || vehicleTypeLabels.other;
};

const VehicleTypeIcon = ({ vehicle, type, className = 'h-5 w-5' }) => {
  const normalizedType = normalizeVehicleType(type || vehicle);
  const Icon = vehicleTypeIcons[normalizedType] || CircleDot;

  return <Icon className={className} />;
};

export default VehicleTypeIcon;
